import Game from '../game';
import Behaviour from '../behaviour';
import Element from '../element/element';
import Ship from '../element/ship/ship';
import { CoordsType } from '../../utils/geometry';
import { Iterator } from '../../utils/types';


export type OrderType = Order;
export default abstract class Order {
  behaviour!: Behaviour;
  x!: number;
  y!: number;
  color!: string;

  abstract update(modifier: number): OrderType;
  abstract isComplete(modifier: number): boolean;
  abstract onComplete(modifier: number): void;
  onStart(): void {
    return;
  }
  isPossible(): boolean {
    return true;
  }

  isLastOrder(): boolean {
    return (this.behaviour.orders.length === 1);
  }

  getElement(): Ship {
    return this.behaviour.element;
  }

  getElements(): Iterator<Element> {
    return this.behaviour.element.scene.elements;
  }

  getStartCoords(index = 0): CoordsType {
    if (index === 0) {
      return {
        x: this.behaviour.element.x,
        y: this.behaviour.element.y,
      };

    }
    else
      return this.behaviour.orders[index - 1].getEndCoords();
  }

  getEndCoords(): CoordsType {
    return {
      x: this.x,
      y: this.y,
    };
  }

  getCoords(index: number): { start: CoordsType, end: CoordsType } {
    return {
      start: this.getStartCoords(index),
      end: this.getEndCoords(),
    };
  }

  draw(index: number): CanvasRenderingContext2D {
    const context = Game.instance.contexts.fogCanvas;

    const {
      start: {
        x: startX,
        y: startY,
      },
      end: {
        x: endX,
        y: endY,
      }
    } = this.getCoords(index);

    context.save();
    context.strokeStyle = this.color;
    context.setLineDash([5 / this.getElement().scene.zoomRatio, 10 / this.getElement().scene.zoomRatio]);
    context.lineWidth = 1 / this.getElement().scene.zoomRatio;
    context.beginPath();
    context.moveTo(startX, startY);
    context.lineTo(endX, endY);
    context.stroke();
    context.restore();
    return context;
  }
}
